import React from 'react'

const DatenschutzPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Datenschutzerklärung</h1>
      <div className="space-y-4 text-gray-700 dark:text-gray-200 text-sm leading-relaxed">
        <p>
          Wir nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. Personenbezogene Daten werden auf dieser
          Webseite nur im technisch notwendigen Umfang erhoben. In keinem Fall werden die erhobenen Daten verkauft oder
          aus anderen Gründen an Dritte weitergegeben.
        </p>
        <p><strong>Verantwortlicher:</strong> Kim Haisch, Furtwänglerstraße 4, 79117 Freiburg im Breisgau,
          info@qualyz.de</p>
        <p><strong>Server-Logs:</strong> Beim Aufruf der Seiten werden automatisch Daten (IP-Adresse, Browsertyp,
          Datum/Uhrzeit) erhoben und in Logfiles gespeichert. Diese Daten dienen ausschließlich der technischen
          Bereitstellung und Sicherheit.</p>
        <p><strong>Kontaktformular / E-Mail:</strong> Wenn Sie uns per E-Mail kontaktieren, werden die von Ihnen
          übermittelten Daten zur Bearbeitung der Anfrage gespeichert.</p>
        <p><strong>Cookies & lokale Speicherung:</strong> Für Login-Sessions und Einstellungen können Cookies oder
          localStorage verwendet werden. Sie können dies in Ihrem Browser unterbinden.</p>
        <p><strong>Betroffenenrechte:</strong> Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung
          der Verarbeitung sowie Widerspruch. Kontakt: info@qualyz.de.</p>
      </div>
    </div>
  )
}

export default DatenschutzPage




